module.exports = __webpack_public_path__ + "25ad8d1b471db8cc26d864db84a86bd5.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensanslight.ttf
// module id = 685
// module chunks = 57